<section class="section-div">
  <div class="content-details">
    <div class="title-details">
      <div class="d-flex">
        <h4>{{ datas }} Incubatee Details</h4>
      </div>
    </div>
    <div class="blog-add-content mt-3">
      <form action="" [formGroup]="incubateeForm">
        <div class="row">
          <div class="col-lg-9 col-md-9 col-sm-12 col-12">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Incubatee Name
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Incubatee Name"
                      formControlName="incubateeName"
                      [ngClass]="{
                        'is-invalid':
                          add.incubateeName.touched && add.incubateeName.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.incubateeName.touched && add.incubateeName.errors
                      "
                    >
                      <span *ngIf="add.incubateeName.errors.required"
                        >Incubatee Name is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Email ID <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Email ID"
                      formControlName="email"
                      (keydown.space)="$event.preventDefault()"
                      oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                      type="text"
                      [ngClass]="{
                        'is-invalid': add.email.touched && add.email.errors
                      }"
                    />
                    <mat-error *ngIf="add.email.touched && add.email.errors">
                      <span *ngIf="add.email.errors.required"
                        >Email Id is required</span
                      >
                      <span *ngIf="add.email.errors.email">
                        <i class="fas fa-exclamation-triangle"></i>
                        Invalid Email
                      </span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Phone Number
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Phone Number"
                      formControlName="phone"
                      oninput="this.value = this.value.replace(/[^0-9.]/g,'')"
                      maxlength="10"
                      minlength="10"
                      [ngClass]="{
                        'is-invalid': add.phone.touched && add.phone.errors
                      }"
                    />
                    <mat-error *ngIf="add.phone.touched && add.phone.errors">
                      <span *ngIf="add.phone.errors.required"
                        >Phone Number is required</span
                      >
                      <span *ngIf="add.phone.errors.pattern">
                        <i class="fas fa-exclamation-triangle"></i>
                        Phone Number is Invalid
                      </span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Startup Name
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Startup Name"
                      formControlName="startupName"
                      [ngClass]="{
                        'is-invalid':
                          add.startupName.touched && add.startupName.errors
                      }"
                    />
                    <mat-error
                      *ngIf="add.startupName.touched && add.startupName.errors"
                    >
                      <span *ngIf="add.startupName.errors.required"
                        >Startup Name is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Registered District
                      <span class="text-danger">*</span></mat-label
                    >
                    <mat-select
                      (selectionChange)="selectIncubator($event.value)"
                      formControlName="registeredDistrict"
                      #DistrictSelect
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="incubatorDistrictFilterCtrl"
                          placeholderLabel="Search Registered District"
                          noEntriesFoundLabel="District not found"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option
                        *ngFor="let list of incubatorDistrictListValue | async"
                        [value]="list.district"
                      >
                        {{ list.district }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="
                        add.registeredDistrict.touched &&
                        add.registeredDistrict.errors
                      "
                    >
                      <span *ngIf="add.registeredDistrict.errors.required"
                        >Registered District is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div
                class="col-lg-4 col-md-4 col-sm-12 col-12"
                *ngIf="otherAddress == true"
              >
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Other District Name
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter District Name"
                      formControlName="otherDistrict"
                      [ngClass]="{
                        'is-invalid':
                          add.otherDistrict.touched && add.otherDistrict.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.otherDistrict.touched && add.otherDistrict.errors
                      "
                    >
                      <span *ngIf="add.otherDistrict.errors.required"
                        >District Name is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div
                class="col-lg-4 col-md-4 col-sm-12 col-12"
                *ngIf="otherAddress == true"
              >
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >State <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter State"
                      formControlName="state"
                      [ngClass]="{
                        'is-invalid': add.state.touched && add.state.errors
                      }"
                    />
                    <mat-error *ngIf="add.state.touched && add.state.errors">
                      <span *ngIf="add.state.errors.required"
                        >State is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div
                class="col-lg-4 col-md-4 col-sm-12 col-12"
                *ngIf="otherAddress == true"
              >
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Country <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Country"
                      formControlName="country"
                      [ngClass]="{
                        'is-invalid': add.country.touched && add.country.errors
                      }"
                    />
                    <mat-error
                      *ngIf="add.country.touched && add.country.errors"
                    >
                      <span *ngIf="add.country.errors.required"
                        >Country is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Availed Schemes
                      <span class="text-danger">*</span></mat-label
                    >
                    <mat-select
                      formControlName="availedSchemes"
                      [ngClass]="{
                        'is-invalid':
                          add.availedSchemes.touched &&
                          add.availedSchemes.errors
                      }"
                    >
                      <mat-option
                        [value]="list"
                        *ngFor="let list of schemesList"
                      >
                        {{ list }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="
                        add.availedSchemes.touched && add.availedSchemes.errors
                      "
                    >
                      <span *ngIf="add.availedSchemes.errors.required"
                        >Availed Schemes is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="text-left">
                  <mat-checkbox
                    class="example-margin"
                    formControlName="femaleFounder"
                  >
                    Women Founder</mat-checkbox
                  >
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="text-left">
                  <mat-checkbox
                    class="example-margin"
                    formControlName="scstFounder"
                  >
                    SC / ST Founder</mat-checkbox
                  >
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >What is the stage of the Incubatee Company / Individual
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter stage of the Incubatee Company"
                      formControlName="incubateeStage"
                      [ngClass]="{
                        'is-invalid':
                          add.incubateeStage.touched && add.email.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.incubateeStage.touched && add.incubateeStage.errors
                      "
                    >
                      <span *ngIf="add.incubateeStage.errors.required"
                        >Stage of the Incubatee Company is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 col-12" class="tab-view">
            <div class="text-center p-relative">
              <div class="circle">
                <img class="profile-pic" [src]="image_urls" />
              </div>
              <div class="p-image">
                <label for="files"
                  ><i class="fa fa-camera upload-button"></i
                ></label>
                <input
                  class="file-upload"
                  (change)="onSelectImage($event)"
                  id="files"
                  type="file"
                  accept="image/*"
                />
              </div>
              <p class="logo-span">Logo <span class="text-danger">*</span></p>
              <p>
                <span class="noti-span"
                  >(Supported Format: png,jpg,jpeg) <br />(Max file size: 10mb)
                  <br />
                  (Suggested Image Dimensions: 160 x 160)</span
                >
              </p>
              <p
                *ngIf="
                  logoCheck &&
                  selecetdImage &&
                  selecetdImage.size / (1024 * 1024) > maxSizeMB
                "
                class="text-danger"
              >
                File size exceeds the limit ({{ maxSizeMB }}MB)
              </p>
              <p *ngIf="logoCheck && !selecetdImage" class="text-danger">
                Logo is required
              </p>
            </div>
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12 col-12">
            <div class="row">
              <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Incorporated Date
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    type="text"
                    placeholder="Datepicker"
                    bsDatepicker
                    [maxDate]="maxDate"
                    [(ngModel)]="incorporatedDate"
                    [bsConfig]="{
                      isAnimated: true,
                      dateInputFormat: 'DD/MM/YYYY'
                    }"
                    formControlName="incorporatedDate"
                    [ngClass]="{
                      'is-invalid':
                        add.incorporatedDate.touched &&
                        add.incorporatedDate.errors
                    }"
                    readonly
                  />
                  <mat-error
                    *ngIf="
                      add.incorporatedDate.touched &&
                      add.incorporatedDate.errors
                    "
                  >
                    <span *ngIf="add.incorporatedDate.errors.required"
                      >Incorporated Date is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Incorporation No/CIN
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Incorporation No/CIN"
                      formControlName="incorporationNoOrCIN"
                      [ngClass]="{
                        'is-invalid':
                          add.incorporationNoOrCIN.touched &&
                          add.incorporationNoOrCIN.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.incorporationNoOrCIN.touched &&
                        add.incorporationNoOrCIN.errors
                      "
                    >
                      <span *ngIf="add.incorporationNoOrCIN.errors.required"
                        >Incorporation No/CIN is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >DPIIT Recognition Number
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter DPIIT Recognition Number"
                      formControlName="registerNoOrRecognitionNo"
                      [ngClass]="{
                        'is-invalid':
                          add.registerNoOrRecognitionNo.touched &&
                          add.registerNoOrRecognitionNo.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.registerNoOrRecognitionNo.touched &&
                        add.registerNoOrRecognitionNo.errors
                      "
                    >
                      <span
                        *ngIf="add.registerNoOrRecognitionNo.errors.required"
                        >DPIIT Recognition Number is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Recognition Date
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    type="text"
                    placeholder="Datepicker"
                    bsDatepicker
                    [maxDate]="maxDate"
                    [(ngModel)]="registeredDate"
                    [bsConfig]="{
                      isAnimated: true,
                      dateInputFormat: 'DD/MM/YYYY'
                    }"
                    formControlName="registeredDate"
                    [ngClass]="{
                      'is-invalid':
                        add.registeredDate.touched && add.registeredDate.errors
                    }"
                    readonly
                  />
                  <mat-error
                    *ngIf="
                      add.registeredDate.touched && add.registeredDate.errors
                    "
                  >
                    <span *ngIf="add.registeredDate.errors.required"
                      >Recognition Date is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Founder Name
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Founder Name"
                      formControlName="founderName"
                      [ngClass]="{
                        'is-invalid':
                          add.founderName.touched && add.founderName.errors
                      }"
                    />
                    <mat-error
                      *ngIf="add.founderName.touched && add.founderName.errors"
                    >
                      <span *ngIf="add.founderName.errors.required"
                        >Founder Name is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    ><span class="text-danger">*</span> Incubation Support
                    Received From
                  </mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Datepicker"
                    bsDatepicker
                    [maxDate]="maxDate"
                    [(ngModel)]="supportReceivedDate"
                    [bsConfig]="{
                      isAnimated: true,
                      dateInputFormat: 'DD/MM/YYYY'
                    }"
                    formControlName="supportReceivedDate"
                    [ngClass]="{
                      'is-invalid':
                        add.supportReceivedDate.touched &&
                        add.supportReceivedDate.errors
                    }"
                    readonly
                  />
                  <mat-error
                    *ngIf="
                      add.supportReceivedDate.touched &&
                      add.supportReceivedDate.errors
                    "
                  >
                    <span *ngIf="add.supportReceivedDate.errors.required"
                      >Incubation Support Received From is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Support Received For
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Support Received For"
                      formControlName="supportDetails"
                      [ngClass]="{
                        'is-invalid':
                          add.supportDetails.touched &&
                          add.supportDetails.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.supportDetails.touched && add.supportDetails.errors
                      "
                    >
                      <span *ngIf="add.supportDetails.errors.required"
                        >Support Received For is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-12 col-12">
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label
                      >Industry Sector
                      <span class="text-danger">*</span></mat-label
                    >
                    <input
                      matInput
                      placeholder="Enter Industry Sector"
                      formControlName="industrySector"
                      [ngClass]="{
                        'is-invalid':
                          add.industrySector.touched &&
                          add.industrySector.errors
                      }"
                    />
                    <mat-error
                      *ngIf="
                        add.industrySector.touched && add.industrySector.errors
                      "
                    >
                      <span *ngIf="add.industrySector.errors.required"
                        >Industry Sector is required</span
                      >
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12 col-12">
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label
                  >Brief Profile of the Startup
                  <span class="text-danger">*</span></mat-label
                >
                <textarea
                  matInput
                  placeholder="Enter Incubatees Schemes"
                  formControlName="profileBrief"
                  cols="30"
                  rows="6"
                  [ngClass]="{
                    'is-invalid':
                      add.profileBrief.touched && add.profileBrief.errors
                  }"
                ></textarea>
                <mat-error
                  *ngIf="add.profileBrief.touched && add.profileBrief.errors"
                >
                  <span *ngIf="add.profileBrief.errors.required"
                    >Brief Profile of the Startup is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="text-center mt-2">
          <button
            class="mr-2 new-btn-color"
            mat-raised-button
            color="primary"
            (click)="saveIncubatee()"
          >
            {{ savelbl }}
          </button>
          <button
            class="mr-2 new-btn-color2"
            mat-raised-button
            color="warn"
            (click)="cancelIncubatee()"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</section>
